exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collective-join[data-v-6085df79] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-direction: column;\n}\n.collective-join__edit-number[data-v-6085df79] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-direction: column;\n}\n.collective-join__edit-btn[data-v-6085df79] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: flex-end;\n}\n.collective-join__edit-btn button[data-v-6085df79] {\n  margin-right: 5px;\n}", ""]);

// exports
